module.exports = __webpack_public_path__ + "media/assets/images/smart_working/7-4-d55e9401c2a18a7aae729a7f77e561c7.png";